/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Winter_Occupied_SetpointInputs */



/**
* | output |
* | --- |
* | "Winter occupation setpoint" |
*
* @param {Winter_Occupied_SetpointInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const winter_occupied_setpoint = /** @type {((inputs?: Winter_Occupied_SetpointInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Winter_Occupied_SetpointInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Winter occupation setpoint")
	return /** @type {LocalizedString} */ ("Consigne occupation hiver")
});